import { useMutation } from "@tanstack/react-query";

import { lookupService } from "@/services/organizationService";

/** Consulta CNPJ na Receita (via backend). Retorna razão, fantasia, endereço,
 * cidade/UF, telefone e e-mail quando disponíveis. */
export function useCnpjLookup() {
  return useMutation({ mutationFn: (cnpj: string) => lookupService.cnpj(cnpj) });
}
